import CircularLoader from "@/components/loading/LoadingComponent";
import { AuthContext } from "@/contexts/AuthContext";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface GuardProps {
    children: React.ReactNode;
}

const StaffGuard = ({ children }: GuardProps) => {
    const { user, loading } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        // If user.isStaff is false then navigate to "/dashboard"
        if (!loading && user) {
            if (!user.isStaff) {
                navigate("/dashboard");
            }
        }
    }, [user, loading, navigate]);

    if (loading) {
        return <CircularLoader />;
    }

    return <>{children}</>;
};

export default StaffGuard;
